<script setup>
const { data } = defineProps(['data'])

const panels = data?.map(({ id, fields: { title, actions } }) => ({
  id,
  title,
  links: actions.filter((a) => a.fields).map(({ sys: { id }, fields: { text, url } }) => ({ id, text, url })),
}))

function trackClick(e, { text, url }) {
  pushEventToDataLayer('custom.menu.link', {
    group: 'footer',
    type: 'UtilityPanelNavigation',
    category: 'MICHAEL HILL',
    label: text,
    info: {
      url,
      element: e?.target?.tagName,
      location: 'footer links',
    },
  })
}
</script>

<template>
  <div class="footer-navi__mobile">
    <Accordion
      v-for="{ id, title, links } of panels"
      :key="id"
      :id="id"
      :title="title"
      :ga-options="{ group: 'footer', info: { location: 'footer links' } }"
      name="footer-navi-accordion"
    >
      <ul>
        <li v-for="{ id, url, text } of links" :key="id">
          <Anchor :id="id" :url="url" @click="trackClick($event, { text, url })">{{ text }}</Anchor>
        </li>
      </ul>
    </Accordion>
  </div>

  <div class="footer-navi__desktop">
    <div v-for="{ id, title, links } of panels" :key="id" :id="id">
      <h3>{{ title }}</h3>
      <ul>
        <li v-for="{ id, url, text } of links" :key="id">
          <Anchor :id="id" :url="url" @click="trackClick($event, { text, url })">{{ text }}</Anchor>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.footer-navi__desktop,
.footer-navi__mobile {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 13rem;

  & ul {
    & li {
      margin-block-end: 1rem;
      list-style: none;

      & a {
        display: inline-block;
        font-size: var(--text-small);
        text-decoration: none;
      }
      & a:hover {
        text-decoration: underline;
      }
    }
  }
}

.footer-navi__mobile {
  flex-direction: column;
  padding-block-start: 0;
  padding-block-end: var(--space-80);
  margin: auto;
}

.footer-navi__desktop {
  h6 {
    font-size: var(--text-small);
    font-weight: bold;
    padding-block: var(--space-50);
  }
  & ul {
    gap: 3rem;
    width: 10rem;
  }
}

.footer-navi__desktop {
  display: none;
}

@media (--desktop) {
  .footer-navi__mobile {
    display: none;
  }
  .footer-navi__desktop {
    display: flex;
  }
}
</style>
